import "./PriceDisplay.css";

// Prices are stored as whole-shilling integers but always DISPLAYED with
// two decimal places (see CLAUDE.md "Price Formatting") — unconditional,
// not just for genuinely fractional values.
const fmt = (n) => `Ksh ${Number(n).toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Shows the stored price. Checkout adds VAT as its own line only when the
// server charges it (VAT_RATE; 0 until Emporia is VAT-registered).
const PriceDisplay = ({ price, compareAtPrice = null, size = "md" }) => {
  const hasDiscount = compareAtPrice && compareAtPrice > price;
  const discountPct = hasDiscount
    ? Math.round((1 - price / compareAtPrice) * 100)
    : 0;

  return (
    <span className={`pd-wrap pd-${size}`}>
      {hasDiscount && (
        <>
          <span className="pd-original" aria-label={`Original price ${fmt(compareAtPrice)}`}>
            {fmt(compareAtPrice)}
          </span>
          <span className="pd-badge" aria-label={`${discountPct}% off`}>
            -{discountPct}%
          </span>
        </>
      )}
      <span
        className={`pd-price${hasDiscount ? " pd-sale" : ""}`}
        aria-label={`${hasDiscount ? "Sale price" : "Price"} ${fmt(price)}`}
      >
        {fmt(price)}
      </span>
    </span>
  );
};

export default PriceDisplay;
